// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__JEd4w {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 25px 80px;

  @media (max-width: 1024px) {
    padding: 20px;
  }
}

.style_header__xvZTF {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 25px;
  gap: 1rem;

  @media (max-width: 550px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.style_header__xvZTF .style_caption__kX9SJ {
  @media (max-width: 750px) {
    width: 65%;
  }

  @media (max-width: 500px) {
    width: auto;
  }
}

.style_headerTitle__0ztL6 {
  @media (max-width: 550px) {
    font-size: 1.2rem !important;
  }
}

.style_headerSubtitle__UyJB0 {
  @media (max-width: 550px) {
    display: none;
  }
}

.style_searchHeader__6Jd4p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  width: 100%;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.style_counter__kGZxV {
  display: flex;
  flex-direction: column;
}

.style_searchBox__b-q81 {
  flex-shrink: 0;

  @media (max-width: 900px) {
    width: 100% !important;
    max-width: none !important;
  }
}

.style_tabs__Swn3y {
  display: flex;
  flex-direction: column;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MachinesList/style.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,SAAS;;EAET;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;;EAET;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;;EAEd;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding: 25px 80px;\n\n  @media (max-width: 1024px) {\n    padding: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 25px;\n  gap: 1rem;\n\n  @media (max-width: 550px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.header .caption {\n  @media (max-width: 750px) {\n    width: 65%;\n  }\n\n  @media (max-width: 500px) {\n    width: auto;\n  }\n}\n\n.headerTitle {\n  @media (max-width: 550px) {\n    font-size: 1.2rem !important;\n  }\n}\n\n.headerSubtitle {\n  @media (max-width: 550px) {\n    display: none;\n  }\n}\n\n.searchHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  width: 100%;\n  gap: 1rem;\n\n  @media (max-width: 900px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.counter {\n  display: flex;\n  flex-direction: column;\n}\n\n.searchBox {\n  flex-shrink: 0;\n\n  @media (max-width: 900px) {\n    width: 100% !important;\n    max-width: none !important;\n  }\n}\n\n.tabs {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__JEd4w`,
	"header": `style_header__xvZTF`,
	"caption": `style_caption__kX9SJ`,
	"headerTitle": `style_headerTitle__0ztL6`,
	"headerSubtitle": `style_headerSubtitle__UyJB0`,
	"searchHeader": `style_searchHeader__6Jd4p`,
	"counter": `style_counter__kGZxV`,
	"searchBox": `style_searchBox__b-q81`,
	"tabs": `style_tabs__Swn3y`
};
export default ___CSS_LOADER_EXPORT___;
